import isOpenAddress from './is-open-address';

export default {
  isOpenAddress,
};
